// extracted by mini-css-extract-plugin
export var orderSummary = "_o2-0";
export var showMoreLessButton = "_o2-1";